/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SupportTicketIncludeFilterItems } from './supportTicketIncludeFilterItems';
import { SupportTicketScopeFilter } from './supportTicketScopeFilter';


export interface SupportTicketIncludeFilterInner { 
    relation?: SupportTicketIncludeFilterInner.RelationEnum;
    scope?: SupportTicketScopeFilter;
}
export namespace SupportTicketIncludeFilterInner {
    export type RelationEnum = 'module' | 'company' | 'businessUnit' | 'department' | 'assignee' | 'comments' | 'history';
    export const RelationEnum = {
        Module: 'module' as RelationEnum,
        Company: 'company' as RelationEnum,
        BusinessUnit: 'businessUnit' as RelationEnum,
        Department: 'department' as RelationEnum,
        Assignee: 'assignee' as RelationEnum,
        Comments: 'comments' as RelationEnum,
        History: 'history' as RelationEnum
    };
}


